"use client";
import * as CheckboxRadix from "@radix-ui/react-checkbox";
import "./CheckboxFilter.scss";
import Balancer from "react-wrap-balancer";
import { Row } from "@/components";
import { PropsWithChildren, ReactNode } from "react";
import clsx from "clsx";
import { CheckIcon, CheckIconCircle } from "@/icons";

type CheckboxFilterProps = PropsWithChildren<{
  id: string;
  label?: ReactNode;
  checked: boolean;
  onChange: (checked: boolean) => void;
  classNameText?: string;
  canMultiple?: boolean;
}>;

export const CheckboxFilter = ({
  id,
  label,
  checked,
  onChange,
  classNameText = "fs-6 fw-bold",
  canMultiple = true,
}: CheckboxFilterProps) => {
  const parser = new DOMParser();
  const html = parser.parseFromString(`${label}`, "text/html");
  const labelText = html?.body?.textContent || "";

  return (
    <Row alignItems="center" gap="x16">
      <Row
        as={"label"}
        gap={"x16"}
        alignItems={"center"}
        py={"x8"}
        htmlFor={id}
        className="cursor-pointer w-full"
      >
        <CheckboxRadix.Root
          id={id}
          checked={checked}
          onCheckedChange={onChange}
          className={clsx(
            canMultiple ? "ui-checkbox-filter-container" : "ui-checkbox-filter",
          )}
          aria-label={labelText}
        >
          <CheckboxRadix.Indicator>
            <div className="checkbox-container">
              {canMultiple ? (
                <CheckIcon width={14} height={14} color="white" />
              ) : (
                <CheckIconCircle width={14} height={14} color="white" />
              )}
            </div>
          </CheckboxRadix.Indicator>
        </CheckboxRadix.Root>
        {label && (
          <Balancer
            as="label"
            htmlFor={id}
            className={clsx(classNameText, "text-slate-20 cursor-pointer")}
          >
            {label}
          </Balancer>
        )}
      </Row>
    </Row>
  );
};
